// src/pages/firm/FirmList.tsx
import React, { useEffect, useState } from "react";
import { useFirmStore } from "../../store/firmStore";
import { useIntegrationStore } from "../../store/integrationStore";
import { useSyncStore } from "../../store/syncStore";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconButton, TextButton } from "../../components/ButtonComponents";
import { Edit, Image, ImageOff, LucideTriangleDashed, Settings, Trash2, Zap, Server, Eraser } from "lucide-react";
import { FirmDialog } from "./FirmDiaog";
import { toast } from "react-toastify";
import { Firm } from "../../types/firm";
import { useDynamicScrollHeight } from "../../hooks/useDynamicScrollHeight";
import { useTableHeader } from "../../hooks/useTableHeader";
import { useConfirmModal } from "../../hooks/useConfirmModal";
import { SyncConfigDialog } from "./SyncConfigDialog";
import { FirmSettingsDialog } from "./FirmSettingsDialog";
import { useFirmSettingsStore } from "../../store/firmSettingsStore";
import { FirmModulesDialog } from "./FirmModulesDialog";
import { FirmEdgeAgentDialog } from "./FirmEdgeAgentDialog";
import { FirmClearDataDialog } from "./FirmClearDataDialog"; 
  const formatCapacity = (usedMB: number, totalGB: number) => {
  // Eğer totalGB tanımlanmamış veya 0 ise hata oluşmaması için direkt 0 dönelim
  if (!totalGB || totalGB <= 0) {
    return {
      displayText: `${(usedMB / 1024).toFixed(2)} GB / 0 GB`,
      percentage: "0.0",
      percentageValue: 0,
      isFull: usedMB > 0 // Kapasite 0 ama veri varsa dolu sayılır
    };
  }

  const usedGB = (usedMB / 1024).toFixed(2);
  const numericPercentage = Math.min(((usedMB / (totalGB * 1024)) * 100), 100);
  
  return {
    displayText: `${usedGB} GB / ${totalGB.toFixed(2)} GB`,
    percentage: numericPercentage.toFixed(1),
    percentageValue: numericPercentage,
    isFull: (usedMB / 1024) >= totalGB
  };
};
export const FirmList = () => {
  const { data: firmData, total: firmTotal, loading: firmLoading, fetchDataDynamic: fetchFirms, createItem, updateItem, deleteItem } = useFirmStore();
  const { data: integrationApplications, fetchDataDynamic: fetchApps } = useIntegrationStore();
  const { fetchConfig, loading: syncLoading } = useSyncStore();
const { fetchSettings, saveSettings } = useFirmSettingsStore();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firmToEdit, setFirmToEdit] = useState<Firm | null>(null);
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);
  const [activeConfig, setActiveConfig] = useState<any>(null);
  const [activeFirmName, setActiveFirmName] = useState("");
const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
const [activeSettings, setActiveSettings] = useState<any>(null);
  const scrollHeight = useDynamicScrollHeight(260);
  const { confirm, modal: confirmModal } = useConfirmModal();
const [isModulesModalOpen, setIsModulesModalOpen] = useState(false);
  const [selectedFirmId, setSelectedFirmId] = useState<number | null>(null);
  
  // Edge Agent State
  const [isEdgeAgentModalOpen, setIsEdgeAgentModalOpen] = useState(false);
  const [firmToEdgeAgent, setFirmToEdgeAgent] = useState<Firm | null>(null);

  // Clear Data State
  const [isClearDataModalOpen, setIsClearDataModalOpen] = useState(false);
  const [firmToClearData, setFirmToClearData] = useState<Firm | null>(null);

  useEffect(() => {
    fetchApps({ pageSize: 9999, filter: { field: 'isActive', operator: 'eq', value: true } });
  }, []);
  const handleResetFirmData = async (firm: Firm) => {
    const isConfirmed = await confirm(
      `${firm.name} firmasına ait TÜM senkronize veriler (Stok, Fiyat, Cari) kalıcı olarak silinecek. Emin misiniz?`
    );

    if (isConfirmed) {
      const result = await useSyncStore.getState().resetFirmData(firm.id);
      if (result.success) {
        toast.success(`Veriler temizlendi: ${result.stats.stocks} stok, ${result.stats.prices} fiyat silindi.`);
      } else {
        toast.error("Temizlik sırasında bir hata oluştu.");
      }
    }
  };
  const handleShowModules = (firm: Firm) => {
    setSelectedFirmId(firm.id);
    setActiveFirmName(firm.name);
    setIsModulesModalOpen(true);
  };
  const handleResetSyncData = async (firm: Firm) => {
  const isConfirmed = await confirm(
    `${firm.name} firmasına ait SADECE dışarıdan gelen (Sync) veriler silinecek. Manuel kayıtlar korunacak. Emin misiniz?`
  );

  if (isConfirmed) {
    const result = await useSyncStore.getState().resetSyncData(firm.id);
    if (result.success) {
      toast.success(`Veriler temizlendi: ${result.stats.stocks} stok, ${result.stats.prices} fiyat silindi.`);
      fetchFirms(); // Listeyi yenile (Kapasite değişmiş olabilir)
    } else {
      toast.error("Veri temizleme sırasında bir hata oluştu.");
    }
  }
};

const handleClearImages = async (firm: Firm) => {
  const isConfirmed = await confirm(
    `${firm.name} firmasına ait TÜM resimler ve disk alanı temizlenecek. Bu işlem geri alınamaz. Emin misiniz?`
  );

  if (isConfirmed) {
    const result = await useSyncStore.getState().clearFirmImages(firm.id);
    if (result.success) {
      toast.success(`Resim silindi ve kota sıfırlandı.`);
      fetchFirms(); // Kapasite barının güncellenmesi için önemli
    } else {
      toast.error("Resimler temizlenirken bir hata oluştu.");
    }
  }
};

const handleClearFirmData = (firm: Firm) => {
  setFirmToClearData(firm);
  setIsClearDataModalOpen(true);
};
  const handleShowConfig = async (firm: Firm) => {
    const config = await fetchConfig(firm.id);
    if (config) {
      setActiveConfig(config);
      setActiveFirmName(firm.name);
      setIsConfigModalOpen(true);
    } else {
      toast.error("Konfigürasyon alınamadı.");
    }
  };

const handleShowSettings = async (firm: Firm) => {
    const data = await fetchSettings(firm.id);
    if (data) {
      // Eğer ayar hiç yoksa (null geldiyse) firmId'yi içine ekle ki save ederken hata olmasın
      setActiveSettings(data.firmId ? data : { ...data, firmId: firm.id });
      setActiveFirmName(firm.name);
      setIsSettingsModalOpen(true);
    }
  };

  const handleDeleteClick = async (firm: Firm) => {
    if (await confirm(`${firm.name} silinsin mi?`)) {
      await deleteItem(firm.id);
      fetchFirms();
    }
  };
  const handleEditClick = (firm: Firm) => {
    setFirmToEdit(firm);
    setIsModalOpen(true);
  };

  // Dialog kapatma fonksiyonu (Hata 88 için)
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFirmToEdit(null);
  };

const actionBodyTemplate = (firm: Firm) => (
  <div className="flex gap-1">
    <IconButton 
  onClick={() => handleShowSettings(firm)} 
  icon={Settings} // veya Lucide'dan Cog/Settings
  className="text-gray-600" 
  title="Firma Genel Ayarları" 
/>
<IconButton 
      onClick={() => handleShowModules(firm)} 
      icon={Zap} 
      className="text-yellow-600 hover:bg-yellow-50" 
      title="SaaS Paket & Modül Yetkileri" 
    />
    
    <IconButton 
      onClick={() => { setFirmToEdgeAgent(firm); setIsEdgeAgentModalOpen(true); }} 
      icon={Server} 
      className="text-teal-600 hover:bg-teal-50" 
      title="Edge Agent Yönetimi" 
    />

     
    <IconButton onClick={() => handleEditClick(firm)} icon={Edit} className="text-blue-600" title="Düzenle" />
    <IconButton onClick={() => handleShowConfig(firm)} icon={Settings} className="text-purple-600" title="Sync Ayarları" />

    {/* VERİ SIFIRLAMA (TURUNCU) */}
    <IconButton
      onClick={() => handleResetSyncData(firm)}
      icon={LucideTriangleDashed}
      className="text-orange-600 hover:bg-orange-100"
      title="Sync Verilerini Temizle (Manuel Kayıtlar Kalır)"
    />

    {/* RESİM SIFIRLAMA (MAVİ/GÖKYÜZÜ) - Lucide'dan Image ikonu ekleyebilirsin */}
    <IconButton
      onClick={() => handleClearImages(firm)}
      icon={ImageOff} // Buraya lucide'dan Image ikonu import edip koyabilirsin
      className="text-cyan-600 hover:bg-cyan-100"
      title="Sadece Resimleri Temizle"
    />

    {/* TÜM HAREKET VERİLERİNİ TEMİZLEME (KIRMIZI-SARI UYARI RENGİ) */}
    <IconButton
      onClick={() => handleClearFirmData(firm)}
      icon={Eraser}
      className="text-pink-600 hover:bg-pink-100"
      title="Firma Hareket Verilerini (Sipariş/Görev/Ziyaret) Temizle"
    />

    <IconButton onClick={() => handleDeleteClick(firm)} icon={Trash2} className="text-red-500" title="Firmayı Tamamen Sil" />
  </div>
);

  return (
    <div className="w-full">
      {confirmModal}
      <DataTable
        value={firmData}
        header={useTableHeader({
          title: "Firmalar",
          actions: <TextButton onClick={() => setIsModalOpen(true)}>Yeni Ekle</TextButton>,
          // Hata 73 Çözümü: null gelirse undefined'a çeviriyoruz
          onFilterChange: (f) => fetchFirms({ filter: f ?? undefined })
        }).header}
        paginator
        lazy
        rows={rows}
        first={first}
        totalRecords={firmTotal}
        onPage={(e) => {
          setFirst(e.first);
          setRows(e.rows);
          // Hata 75 Çözümü: e.page yerine matematiksel hesaplama (daha güvenli)
          const currentPage = Math.floor(e.first / (e.rows || 10)) + 1;
          fetchFirms({ pageIndex: currentPage, pageSize: e.rows });
        }}
        loading={firmLoading}
        scrollable
        scrollHeight={scrollHeight}
      >
        <Column field="id" header="ID" />
        <Column field="name" header="Firma Adı" />
        <Column field="app" header="Uygulama" />
        <Column field="subscriptionType" header="Abonelik Tipi" />
<Column 
  header="Kapasite Kullanımı" 
  style={{ minWidth: "200px" }}
  body={(rowData) => {
    // totalCapacity 0 gelse bile formatCapacity artık güvenli
    const { displayText, percentage, percentageValue, isFull } = formatCapacity(
      rowData.usedCapacity || 0, 
      rowData.totalCapacity || 0
    );
    
    // Kapasite tanımlanmamışsa (0 ise) özel bir durum yönetimi
    const isNotConfigured = (rowData.totalCapacity || 0) <= 0;

    return (
      <div className="w-full">
        <div className="flex justify-between text-xs mb-1">
          <span className={`
            ${isFull ? "text-red-600 font-bold" : "text-gray-600"}
            ${isNotConfigured ? "italic text-orange-500" : ""}
          `}>
            {isNotConfigured ? `Limit Atanmadı (${(rowData.usedCapacity / 1024).toFixed(2)} GB)` : displayText}
          </span>
          <span className="text-gray-500">
            {isNotConfigured ? "-" : `%${percentage}`}
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
          <div 
            className={`h-1.5 rounded-full transition-all duration-500 ${
              isFull ? 'bg-red-500' : percentageValue > 80 ? 'bg-orange-500' : 'bg-green-500'
            }`} 
            style={{ width: `${isNotConfigured && rowData.usedCapacity > 0 ? 100 : percentageValue}%` }}
          ></div>
        </div>
      </div>
    );
  }}
/>
        
        <Column header="İşlemler" body={actionBodyTemplate} align="center" style={{ width: "8rem" }} />

      </DataTable>
<FirmModulesDialog
        isOpen={isModulesModalOpen}
        onClose={() => setIsModulesModalOpen(false)}
        firmId={selectedFirmId || 0}
        firmName={activeFirmName}
      />
      
      <FirmEdgeAgentDialog
        isOpen={isEdgeAgentModalOpen}
        onClose={() => {
          setIsEdgeAgentModalOpen(false);
          setFirmToEdgeAgent(null);
        }}
        firm={firmToEdgeAgent}
        onSaveConfig={() => fetchFirms()}
      />

      <FirmClearDataDialog
        isOpen={isClearDataModalOpen}
        onClose={() => {
          setIsClearDataModalOpen(false);
          setFirmToClearData(null);
        }}
        firm={firmToClearData}
        onSuccess={() => fetchFirms()}
      />
      <SyncConfigDialog
        isOpen={isConfigModalOpen}
        onClose={() => setIsConfigModalOpen(false)}
        config={activeConfig}
        firmName={activeFirmName}
      />
<FirmSettingsDialog
  isOpen={isSettingsModalOpen}
  onClose={() => setIsSettingsModalOpen(false)}
  settings={activeSettings}
  firmName={activeFirmName}
onSave={async (formData) => { 
    const { id, ...cleanData } = formData; 
    
    const success = await saveSettings(cleanData);
    if (success) { 
        setIsSettingsModalOpen(false);
    }
}}
/>
      <FirmDialog
        isOpen={isModalOpen}
        onClose={handleCloseModal} // Düzelttik
        firm={firmToEdit}
        onSave={(data) => firmToEdit ? updateItem(firmToEdit.id, data) : createItem(data)}
        integrationApplications={integrationApplications as any}
      />
    </div>
  );
};